<template>
  <div class="teamDataPage">
    <div class="totalBox">
      <div class="totalCard" :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataTopCardBg.png')+')'}" @click="goDetail()">
        <div class="label">{{$t('lang.invitee.teamMember')}}<img src="../../assets/images/invite/TeamDataArrowRight.png" class="TeamDataArrowRight" alt=""></div>
        <div class="valueBox">
          <img src="../../assets/images/invite/teamMemberIcon.png" alt="" class="icon">
          <div class="value">{{ pageData ? pageData.TeamMembers : '' }}</div>
        </div>
      </div>
      <div class="totalCard" :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataTopCardBg.png')+')'}" @click="inviteFriendsToBoostYourBonusPopOpen()">
        <div class="label">{{$t('lang.invitee.teamLevel')}}<img src="../../assets/images/invite/TeamDataArrowRight.png" class="TeamDataArrowRight" alt=""></div>
        <div class="valueBox">
          <img src="../../assets/images/invite/teamLevelIcon.png" alt="" class="icon">
          <div class="value">{{ $t('lang.invitee.level') }} {{ pageData ? pageData.TeamLevel : '' }}</div>
        </div>
      </div>
    </div>
    <div class="justMore" v-if="showJustMoreType === 1"
         v-html="replaceJustMoreValue($t('lang.invitee.justMore'))"></div>
    <div class="justMore" v-if="showJustMoreType === 2"
         v-html="replaceJustMoreValu2($t('lang.invitee.justMore2'))"></div>
    <div class="teamDataCardBox">
      <div class="head">
        <div :class="active===0?'headItemActive':'headItem'" @click="changeData(0)">
          {{ $t('lang.invitee.yesterdayDownlineData') }}
        </div>
        <div :class="active===1?'headItemActive':'headItem'" @click="changeData(1)">
          {{ $t('lang.invitee.downlineHistory') }}
        </div>
      </div>
      <div v-if="active === 0" class="content"
           :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataCardBg2.png')+')'}">
        <div class="itemCard">
          <!--          <div class="value" v-if="pageData && pageData.YesterdayData">{{formatAmount(pageData.YesterdayData.BetCommission)}}</div>-->
          <div class="value" v-if="pageData && pageData.YesterdayData">
            {{ formatAmount(formatFloat(pageData.YesterdayData.BetCommission)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.teamBetCommission') }}</div>
        </div>
        <div class="itemCard">
          <div class="value" v-if="pageData && pageData.YesterdayData">
            {{ formatAmount(formatFloat(pageData.YesterdayData.Capitation)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.newValidInviteesBonus') }}</div>
        </div>
        <div class="itemCard">
          <div class="value" v-if="pageData && pageData.YesterdayData">
            {{ formatAmount(formatFloat(pageData.YesterdayData.DepositCommission)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.teamDepositCommission') }}</div>
        </div>
      </div>
      <div v-if="active === 1" class="content"
           :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataCardBg2.png')+')'}">
        <div class="itemCard">
          <div class="value" v-if="pageData && pageData.HistoryData">
            {{ formatAmount(formatFloat(pageData.HistoryData.BetCommission)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.teamBetCommission') }}</div>
        </div>
        <div class="itemCard">
          <div class="value" v-if="pageData && pageData.HistoryData">
            {{ formatAmount(formatFloat(pageData.HistoryData.Capitation)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.newValidInviteesBonus') }}</div>
        </div>
        <div class="itemCard">
          <div class="value" v-if="pageData && pageData.HistoryData">
            {{ formatAmount(formatFloat(pageData.HistoryData.DepositCommission)) }}
          </div>
          <div class="value" v-else>0</div>
          <div class="label">{{ $t('lang.invitee.teamDepositCommission') }}</div>
        </div>
      </div>
    </div>
    <div class="tableDataBox"
         :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataTableCardBg.png')+')'}">
      <div class="head">
        <div class="column" :style="{width: columnWith1 + 'vw'}">{{ $t('lang.invitee.date') }}</div>
        <div class="column" :style="{width: columnWith2 + 'vw'}">{{ $t('lang.invitee.teamBetCommission') }}</div>
        <div class="column" :style="{width: columnWith3 + 'vw'}">{{ $t('lang.invitee.teamDepositCommission') }}</div>
        <div class="column" :style="{width: columnWith4 + 'vw'}">{{ $t('lang.invitee.newValidInviteesBonus') }}</div>
      </div>
      <div id="teamDataPageTeamHistoryBody" class="teamDataPageTeamHistoryBody">
        <Loadmore
          :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
          :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
          :bottomLoadingText="$t('lang.loadingStatus.loading')"
          :auto-fill="false"
          :bottom-method="getTeamHistory"
          :bottom-all-loaded="hasLoadAll"
          ref="loadmore">
          <div class="row" v-for="(item,index) in teamHistory" :key="index">
            <div class="column" :style="{width: columnWith1 + 'vw'}">{{ item.LocalData }}</div>
            <div class="column" :style="{width: columnWith2 + 'vw'}">{{ item.BetCommission }}</div>
            <div class="column" :style="{width: columnWith3 + 'vw'}">{{ item.DepositCommission }}</div>
            <div class="column" :style="{width: columnWith4 + 'vw'}">{{ item.Capitation }}</div>
          </div>
          <div class="showMore" v-if="!hasLoadAll">
            <div class="shadow"/>
            <img :src="showMore" alt="">
          </div>
        </Loadmore>
      </div>
    </div>
  </div>
</template>

<script>
import {Loadmore, Toast} from 'mint-ui'
import request from '@/service'
import showMore from '@/assets/images/history/showMore.svg'

export default {
  name: 'teamDataPage',
  props: ['pageData'],
  components: {
    Loadmore,
    Toast
  },
  data () {
    return {
      showMore,
      check: 0,
      PageNum: 0,
      PageSize: 6,
      hasLoadAll: true,
      firstLoad: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      active: 0,
      columnWith1: 18,
      columnWith2: 20,
      columnWith3: 22,
      columnWith4: 27,
      MembersToNextLevel: null, // 到达下一等级所剩余的下级总人数
      DepositAmountToNextLevel: null, // 到达下一等级的下级存款总金额
      showJustMoreType: 1, // 显示tip类型
      teamHistory: []
    }
  },
  watch: {
    pageData: {
      handler (val, oldVal) {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created () {

  },
  mounted () {
    this.getTeamHistory(true)
  },
  methods: {
    formatFloat (nums) {
      if (nums >= 1000 && nums < 10000 && nums % 1 !== 0) {
        return Math.trunc(nums * 10) / 10
      } else {
        return nums
      }
    },
    /**
     * 格式化金额，根据数值大小自动切换单位（K/M/B/T）并添加千位分隔符
     * @param {number} num - 需要格式化的数值
     * @param {boolean} [forceTwoDecimals=false] - 是否强制保留两位小数
     * @returns {string} 格式化后的金额字符串
     */
    formatAmount (num, forceTwoDecimals = false) {
      if (typeof num !== 'number' || isNaN(num)) return 'Invalid'

      const absNum = Math.abs(num)
      // 单位定义：阈值从大到小排序（优先匹配大单位）
      const units = [
        {threshold: 1e12, suffix: 'T', divisor: 1e12}, // 万亿（1,000,000,000,000+）
        {threshold: 1e9, suffix: 'B', divisor: 1e9}, // 十亿（1,000,000,000 ~ 999,999,999,999）
        {threshold: 1e6, suffix: 'M', divisor: 1e6}, // 百万（1,000,000 ~ 999,999,999）
        {threshold: 1e4, suffix: 'K', divisor: 1e3} // 千（10,000 ~ 999,999）⭐ 关键修正：K单位除以1000而非10000
      ]

      // 查找匹配的单位（从大到小匹配）
      const matchedUnit = units.find(unit => absNum >= unit.threshold)

      // 数值 < 10,000：直接返回千分位格式（无单位）
      if (!matchedUnit) {
        return num.toLocaleString('en-US')
      }

      // 计算缩写值（例如：10000 → 10000 / 1000 = 10 → "10K"）
      const shortValue = num / matchedUnit.divisor

      // 动态小数位数逻辑
      let decimals
      if (forceTwoDecimals) {
        decimals = 2 // 强制两位小数
      } else {
        // 根据单位调整小数位数
        if (matchedUnit.suffix === 'K') {
          decimals = 1
        } else if (matchedUnit.suffix === 'M') {
          decimals = 1
        } else {
          decimals = shortValue < 10 ? 2 : 1
        }
      }

      // 格式化为字符串并移除多余小数0
      let formatted = shortValue.toFixed(decimals).replace(/(\.0+|0+)$/, '')
      if (formatted.endsWith('.')) formatted = formatted.slice(0, -1) // 移除末尾多余小数点

      // 为千级（K）和百万级（M）添加千分位（如25,000 → 25K）
      if (matchedUnit.suffix === 'K' || matchedUnit.suffix === 'M') {
        const parts = formatted.split('.')
        parts[0] = Number(parts[0]).toLocaleString('en-US') // 整数部分加千分位
        formatted = parts.join('.')
      }

      return formatted + matchedUnit.suffix
    },
    inviteFriendsToBoostYourBonusPopOpen () {
      this.$emit('inviteFriendsToBoostYourBonusPopOpen')
    },
    init () {
      if (this.pageData && (this.pageData.MembersToNextLevel > 0) && (this.pageData.DepositAmountToNextLevel > 0) && !this.pageData.IsMaxLevel) {
        this.showJustMoreType = 1
      } else if (this.pageData && this.pageData.MembersToNextLevel > 0 && !this.pageData.IsMaxLevel) {
        this.showJustMoreType = 1
      } else if (this.pageData && this.pageData.DepositAmountToNextLevel > 0 && !this.pageData.IsMaxLevel) {
        this.showJustMoreType = 2
      } else {
        this.showJustMoreType = -1
      }

      // if (this.pageData && (this.pageData.MembersToNextLevel >= 0) && (this.pageData.DepositAmountToNextLevel >= 0)) {
      //   this.showJustMoreType = 1
      // } else {
      //   this.showJustMoreType = 2
      // }
    },
    // 查询历史数据， 有分页， PageNum , PageSize, PageSize不写默认值是10
    getTeamHistory (toTop) {
      const url = 'innovation/invite_relation/get/team/history'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : '',
        PageNum: this.PageNum,
        PageSize: this.PageSize
      }
      request('post', url, data).then(res => {
        if (res && res !== -1) {
          if (this.check > 0) {
            this.teamHistory = res.HistoryData
          } else {
            this.teamHistory = this.teamHistory.concat(res.HistoryData)
          }
          this.PageNum += 1
          this.hasLoadAll = this.teamHistory.length >= res.Total
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
          this.check = 0
          if (toTop && toTop === true) {
            setTimeout((e) => {
              document.getElementById('teamDataPageTeamHistoryBody').scrollTo(0, 0)
            })
          }
        }
      })
    },
    replaceJustMoreValue (val) {
      if (this.pageData) {
        return val.replace('{nums}', this.pageData.MembersToNextLevel).replace('{level}', this.pageData.TeamLevel + 1)
      } else {
        return val.replace('{nums}', '-').replace('{level}', '-')
      }
    },
    replaceJustMoreValu2 (val) {
      if (this.pageData) {
        return val.replace('{nums}', this.pageData.DepositAmountToNextLevel).replace('{level}', this.pageData.TeamLevel + 1)
      } else {
        return val.replace('{nums}', '-').replace('{level}', '-')
      }
    },
    openInvitePop () {
      this.$emit('openInvitePop')
    },
    goDetail () {
      this.$router.push('/EarnDetails')
    },
    changeData (value) {
      this.active = value
    }
  }
}
</script>

<style lang="less" scoped>
.showMore {
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 100vw;
  height: 16vw;
  text-align: center;

  .shadow {
    position: absolute;
    bottom: 12vw;
    width: 100%;
    background: linear-gradient(180deg, rgba(22, 22, 22, 0) 0%, #161616 75.93%);
    height: 26.389vw;
    z-index: 0;
  }

  img {
    position: relative;
    width: 3.611vw;
    z-index: 1;
  }
}

.teamDataPage {
  display: flex;
  flex-direction: column;
  padding-bottom: 4vw;
  align-items: center;
  overflow: hidden;
  width: 95vw;

  .totalBox {
    width: 95vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14vw;
    .totalCard{
      width: 45.511vw;
      height: 22.333vw;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4vw;

      .label {
        color: #A1A1A1;
        font-size: 3.611vw;
        font-weight: 600;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 0 2vw 0 3.194vw;
        position: relative;
        top: -1vw;
        .TeamDataArrowRight{
          //position:  absolute;
          //right: -8vw;
          //top: -2vw;
          height: 7.5vw;
          width: 7.5vw;

        }
      }

      .valueBox {
        display: flex;
        align-items: center;
        gap: 2vw;
        width: 100%;
        padding-left: 4.166vw;
        position: relative;
        top: -1vw;
        .icon{
          height: 4vw;
          width: 4.8vw;
        }
        .value{
          font-size: 4.166vw;
          color: #fff;
          font-weight: 600;
          position: relative;
          top: 0.5vw;
        }
      }
    }
  }

  .justMore {
    font-size: 3.422vw;
    color: #505050;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 3vw 0;
  }

  .teamDataCardBox {
    margin-top: 1vw;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 50vw;
    //border: 1px solid;
    .head {
      height: 11.111vw;
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      top: 0.5vw;

      .headItem {
        height: 100%;
        flex: 1;
        border-radius: 1.5vw 1.5vw 0vw 0vw;
        background-color: rgb(34, 34, 34);
        font-size: 3.344vw;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .headItemActive {
        height: 100%;
        flex: 1;
        border-radius: 1.5vw 1.5vw 0vw 0vw;
        background-color: rgb(47, 47, 47);
        font-size: 3.344vw;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }

    .content {
      flex: 1;
      width: 100%;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 4vw;

      .itemCard {
        height: 32.944vw;
        width: 25.777vw;
        background-color: #171717;
        border-radius: 3.055vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4vw;

        .value {
          font-size: 6.944vw;
          color: #fff;
          font-weight: 700;
        }

        .label {
          width: 23vw;
          font-size: 3.5vw;
          display: flex;
          align-items: center;
          text-align: center;
        }
      }
    }
  }

  .tableDataBox {
    width: 100%;
    height: 66vw;
    background-size: 100% 100%;
    margin-top: 4vw;
    display: flex;
    flex-direction: column;
    font-size: 3.1vw;
    font-weight: 700;
    padding: 0 1vw;
    overflow: hidden;

    .head {
      width: 100%;
      height: 11vw;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .column {
        text-align: center;
      }
    }

    .teamDataPageTeamHistoryBody {
      flex-shrink: 0;
      width: 100%;
      height: 55vw;
      color: #fff;
      display: flex;
      flex-direction: column;
      padding: 2vw 1.44vw;
      padding-bottom: 0;
      font-weight: 500;
      overflow: auto;

      ::-webkit-scrollbar {
        width: 0 !important;
      }

      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 8vw;

        .column {
          text-align: center;
        }
      }
    }
  }
}

.mint-loadmore {
  padding-top: 2vw;
}

.showMore {
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 100vw;
  height: 16vw;
  text-align: center;

  .shadow {
    position: absolute;
    bottom: 12vw;
    width: 100%;
    background: linear-gradient(180deg, rgba(22, 22, 22, 0) 0%, #161616 75.93%);
    height: 26.389vw;
    z-index: 0;
  }

  img {
    position: relative;
    width: 3.611vw;
    z-index: 1;
  }
}

/deep/ .mint-loadmore {
  overflow-x: hidden;
  overflow-y: auto;
}

/deep/ .mint-loadmore-bottom {
  display: none;
}

/deep/ .showMore > .shadow {
  display: none;
}

///deep/ .showMore{
//  display: none;
//}
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/teamDataPage.vue